import { defineMessages } from "react-intl";
export default defineMessages({
  sunrise: {
    "id": "astral.sunrise",
    "defaultMessage": "Sunrise"
  },
  sunset: {
    "id": "astral.sunset",
    "defaultMessage": "Sunset"
  },
  sunriseAndSunset: {
    "id": "astral.sunriseAndSunset",
    "defaultMessage": "Sunrise and sunset"
  },
  dawn: {
    "id": "astral.dawn",
    "defaultMessage": "Dawn"
  },
  astronomicalSunPhase: {
    "id": "astral.astronomicalSunPhase",
    "defaultMessage": "Astronomical {sunPhase}"
  },
  nauticalSunPhase: {
    "id": "astral.nauticalSunPhase",
    "defaultMessage": "Nautical {sunPhase}"
  },
  civilSunPhase: {
    "id": "astral.civilSunPhase",
    "defaultMessage": "Civil {sunPhase}"
  },
  noon: {
    "id": "astral.noon",
    "defaultMessage": "Noon"
  },
  dusk: {
    "id": "astral.dusk",
    "defaultMessage": "Dusk"
  },
  totalDaylight: {
    "id": "astral.totalDaylight",
    "defaultMessage": "Total daylight"
  },
  remainingDaylight: {
    "id": "astral.remainingDaylight",
    "defaultMessage": "Remaining daylight"
  },
  moon: {
    "id": "astral.moon",
    "defaultMessage": "Moon"
  },
  moonPhases: {
    "id": "astral.moonPhases",
    "defaultMessage": "Moon phases"
  },
  newMoon: {
    "id": "astral.newMoon",
    "defaultMessage": "New moon"
  },
  waxingCrescent: {
    "id": "astral.waxingCrescent",
    "defaultMessage": "Waxing crescent"
  },
  firstQuarter: {
    "id": "astral.firstQuarter",
    "defaultMessage": "First quarter"
  },
  waxingGibbous: {
    "id": "astral.waxingGibbous",
    "defaultMessage": "Waxing gibbous"
  },
  fullMoon: {
    "id": "astral.fullMoon",
    "defaultMessage": "Full moon"
  },
  waningGibbous: {
    "id": "astral.waningGibbous",
    "defaultMessage": "Waning gibbous"
  },
  lastQuarter: {
    "id": "astral.lastQuarter",
    "defaultMessage": "Last quarter"
  },
  waningCrescent: {
    "id": "astral.waningCrescent",
    "defaultMessage": "Waning crescent"
  },
  moonrise: {
    "id": "astral.moonrise",
    "defaultMessage": "Moonrise"
  },
  moonset: {
    "id": "astral.moonset",
    "defaultMessage": "Moonset"
  }
});